import ProductResults from "./ProductResults.jsx";
import {
  buildBavautoEtkUrl,
  isBmwVinForEtk,
} from "@/utils/bavautoEtk.js";

export default function PartsTable({
  t,
  parts,
  loading,
  catalogNotice = "",
  realoemUrl = "",
  vehicleVinFull = "",
  vehicleVinLast7 = "",
  vehicleBrand = "",
  productsByOem,
  loadingOem,
  onSearchProducts,
}) {
  const etkVehicle = {
    brand: vehicleBrand,
    vin_full: vehicleVinFull,
    vin_last7: vehicleVinLast7,
  };
  const showBmwCatalogLinks = isBmwVinForEtk(etkVehicle);
  const bavautoEtkHref = showBmwCatalogLinks
    ? buildBavautoEtkUrl(vehicleVinFull, vehicleVinLast7)
    : "";

  const vinLast7Clean = String(vehicleVinLast7 || "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(-7);
  const realoemCatalogHref =
    typeof realoemUrl === "string" && /realoem\.com\/bmw/i.test(realoemUrl)
      ? realoemUrl
      : showBmwCatalogLinks && /^[A-Z0-9]{7}$/.test(vinLast7Clean)
        ? `https://www.realoem.com/bmw/enUS/select?vin=${encodeURIComponent(vinLast7Clean)}`
        : "";

  /** Banner NHTSA: RealOEM + BavAUTO doar pentru VIN BMW/MINI (identificare ca în isBmwVinForEtk). */
  const realoemNhtsaBannerHref = showBmwCatalogLinks
    ? realoemCatalogHref ||
      (/^[A-Z0-9]{7}$/.test(vinLast7Clean)
        ? `https://www.realoem.com/bmw/enUS/select?vin=${encodeURIComponent(vinLast7Clean)}`
        : "https://www.realoem.com/bmw/enUS/")
    : "";

  const vpicPortalHref = "https://vpic.nhtsa.dot.gov/";
  if (loading) {
    return (
      <p className="text-sm text-slate-600 py-8" role="status">
        {t.loading}
      </p>
    );
  }

  if (!parts || parts.length === 0) {
    if (catalogNotice === "nhtsa_fallback") {
      return (
        <div className="text-sm text-slate-700 py-8 border border-dashed border-[#d7deea] rounded-lg px-4 bg-white/80 space-y-3">
          <p className="leading-relaxed">{t.partsNhtsaNoCatalog}</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 items-baseline">
            {showBmwCatalogLinks && realoemNhtsaBannerHref ? (
              <a
                href={realoemNhtsaBannerHref}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-[#0b378c] underline"
              >
                {t.partsCatalogLinkRealoem}
              </a>
            ) : null}
            <a
              href={vpicPortalHref}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-[#0b378c] underline"
            >
              {t.partsCatalogLinkVpic}
            </a>
            {showBmwCatalogLinks && bavautoEtkHref ? (
              <a
                href={bavautoEtkHref}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-[#0b378c] underline"
              >
                {t.partsCatalogLinkEtk}
              </a>
            ) : null}
          </div>
        </div>
      );
    }
    return (
      <p className="text-sm text-slate-600 py-8 border border-dashed border-[#d7deea] rounded-lg px-4">
        {t.emptyParts}
      </p>
    );
  }

  return (
    <div className="space-y-3">
      {realoemCatalogHref ? (
        <p className="text-sm text-slate-700 px-1">
          <a
            href={realoemCatalogHref}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-[#0b378c] underline"
          >
            {t.partsCatalogLinkRealoem}
          </a>
        </p>
      ) : null}
      <div className="overflow-x-auto rounded-xl border border-[#e2e6ec] bg-white shadow-sm">
        <table className="min-w-full text-sm">
          <thead className="bg-[#f7f8fa] text-left text-[11px] font-mono uppercase tracking-[0.14em] text-slate-600">
            <tr>
              <th className="px-4 py-3">{t.partsTitle}</th>
              <th className="px-4 py-3">OEM</th>
              <th className="px-4 py-3 w-[1%] whitespace-nowrap" />
            </tr>
          </thead>
          <tbody>
            {parts.map((p) => (
              <tr key={p.oem_number} className="border-t border-[#eef0f4] align-top">
                <td className="px-4 py-3 text-[#0b1220]">{p.part_name}</td>
                <td className="px-4 py-3 font-mono text-xs">{p.oem_number}</td>
                <td className="px-4 py-3">
                  <button
                    type="button"
                    onClick={() => onSearchProducts(p.oem_number)}
                    disabled={Boolean(loadingOem && loadingOem === p.oem_number)}
                    className="text-xs font-bold uppercase tracking-wide text-[#0b378c] hover:underline disabled:opacity-50"
                  >
                    {loadingOem === p.oem_number ? t.loading : t.searchProducts}
                  </button>
                  {p.diagram_url ? (
                    <a
                      href={p.diagram_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ml-3 text-xs text-slate-600 underline"
                    >
                      {t.diagramLink}
                    </a>
                  ) : null}
                  <ProductResults
                    t={t}
                    oem={p.oem_number}
                    products={productsByOem[p.oem_number]}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
